<template>
  <b-form-group
    :description="helptext"
  >
    <label :for="name">{{ label }}</label>
    <b-form-file
      :id="name"
      v-model="state"
      :plain="true"
    />
    <div class="image-holder">
      <img class="image-preview" :src="preview" alt="" v-if="preview!==''">
      <b-button variant="outline-danger" @click="state=''" v-if="preview!==''">Remove</b-button>
    </div>
    <div v-if="checkType(formHandle)">
      <div class="invalid-feedback d-block" v-for="error in errors" :key="error">{{ errorMessage[error] }}</div>
    </div>
  </b-form-group>
</template>

<script>
export default {
  data: () => {
    return {
      state: '',
      preview: ''
    }
  },
  props: {
    checkKey: {
      type: String | Number,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    model: {
      type: String | Number
    },
    name: {
      type: String,
      default: ''
    },
    handler: {
      type: Array | Object
    },
    formData: {
      type: Array | Object
    },
    helptext: {
      type: String,
      default: ''
    }
  },
  model: {
    prop: 'model',
    event: 'updateModel'
  },
  created () {
    this.state = this.model
  },
  watch: {
    'state': function () {
      this.handleFileChange()
    }
  },
  methods: {
    handleFileChange () {
      this.preview = (!this.state || this.state === '') ? '' : (typeof this.state === 'object') ? URL.createObjectURL(this.state) : this.state
      this.$emit('updateModel', this.state)
      this.$emit('change')
    },
    clearImage () {
      this.state = ''
    },
    checkErrors (formHandle) {
      return Object.getOwnPropertyNames(formHandle).filter(x => {
        return formHandle[x] === false && x[0] !== '$'
      })
    },
    checkType (formHandle) {
      if (Object.keys(formHandle).includes('$each')) {
        if (formHandle.$each[this.checkKey]) {
          return !!(formHandle.$each[this.checkKey].$error)
        }
        return false
      } else {
        return formHandle.$error
      }
    }
  },
  computed: {
    errors: function () {
      if (Object.keys(this.formHandle).includes('$each')) {
        return this.checkErrors(this.formHandle.$each[this.checkKey])
      } else {
        return this.checkErrors(this.formHandle)
      }
    },
    formHandle: function () {
      let data = this.name.split('.').reduce((acc, curr) => {
        return acc[curr]
      }, this.handler.form)
      return data
    },
    errorMessage: function () {
      let data = this.name.split('.').reduce((acc, curr) => {
        return acc[curr]
      }, this.formData.errorMessages)
      return data
    }
  }
}
</script>

<style>
.image-holder {
  width: 100%;
  height: 100%
}
.image-preview {
  margin: 5px 0;
  width: 100%;
  height: 100%;
}
.image-holder button {
  margin: 5px 0
}
</style>


// WEBPACK FOOTER //
// src/components/custom/PImage.vue